export const GET_USER_LIST_QUERY = `
query getUserList {
  auth_user(where: {roles: {role: {_in: [TENANT_ADMIN,COORDINATOR,PROCTOR_ADMIN]}}}) {
    email
    name
    id
  }
}`;
